import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  text: string
}

const PoolTypeInfoBox = ({ icon, text }: Props) => (
  <Box flexDirection="row" gap="s2" alignItems="center" justifyContent="center">
    <Icon.Medium icon={icon} color="grey800" />
    <Text size="200" color="grey800">
      {text}
    </Text>
  </Box>
)

export default PoolTypeInfoBox
